import React, { useState, useEffect } from "react";
import "../../../css/Marketing/AddMarketingItems.css";
import PrimaryButton from "../../DesignSystem/Buttons/PrimaryButton";
import { db, auth } from "../../../backend/firebaseConfig";
import { getStorage, ref, listAll, getDownloadURL } from "firebase/storage";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { useUserPermissions } from "../../SignIn/UserPermissionsContext";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close.svg";
import NewInputField from "../../DesignSystem/Inputs/NewInputField";
import NewTextArea from "../../DesignSystem/Inputs/NewTextArea";
import CustomSelect from "../../DesignSystem/Dropdowns/CustomSelect";

const AddMedia = () => {
  // Use state for newMedia so React tracks changes
  const [newMedia, setNewMedia] = useState({
    // title: "",
    link: "",
    content: "",
    image: "",
  });

  const [errors, setErrors] = useState({});
  const [images, setImages] = useState([]);
  const [media, setMedia] = useState([]);
  const { userPermissions } = useUserPermissions();
  const [isEditing, setIsEditing] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  useEffect(() => {
    fetchImages();
    fetchMedia();
  }, []);

  useEffect(() => {
    if (images.length > 0 && !newMedia.image) {
      setNewMedia((prev) => ({
        ...prev,
        image: images[0].url,
      }));
    }
  }, [images]);

  const fetchMedia = async () => {
    const docRef = doc(db, "Marketing", "Media");
    const docSnap = await getDoc(docRef);

    setMedia(docSnap.exists() ? docSnap.data().items : []);
    if (docSnap.exists()) {
      // console.log("Media:", docSnap.data().items); // Logs the array of media
    } else {
      // console.log("No media found");
    }
  };

  const fetchImages = async () => {
    const storage = getStorage();
    const imagesRef = ref(storage, "Marketing/Blogs & Media/"); // Folder path

    try {
      const result = await listAll(imagesRef);
      const imageList = await Promise.all(
        result.items.map(async (item) => {
          const fullName = item.name; // Full filename with extension
          const nameWithoutExt = fullName.replace(/\.[^/.]+$/, ""); // Remove extension
          return {
            name: nameWithoutExt, // Filename without extension
            url: await getDownloadURL(item), // Full image URL
          };
        })
      );
      setImages(imageList); // Store {name, url} pairs in state
    } catch (error) {
      // console.error("Error fetching images:", error);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!newMedia.content.trim()) newErrors.content = "Content is required";
    if (!newMedia.link.trim()) newErrors.link = "Link is required";
    if (!newMedia.image.trim()) newErrors.image = "Image is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();

    if (validateForm()) {
      try {
        const docRef = doc(db, "Marketing", "Media");
        const docSnap = await getDoc(docRef);
        let updatedMedia = docSnap.exists() ? docSnap.data().items : [];

        if (isEditing && editIndex !== null) {
          updatedMedia[editIndex] = {
            ...newMedia,
            postedOn: new Date(),
            postedBy:
              auth.currentUser.displayName || auth.currentUser.email || "",
          };
        } else {
          updatedMedia = [
            {
              ...newMedia,
              postedOn: new Date(),
              postedBy:
                auth.currentUser.displayName || auth.currentUser.email || "",
            },
            ...updatedMedia,
          ];
        }

        await setDoc(docRef, { items: updatedMedia }, { merge: true });

        // console.log(isEditing ? "Media Updated" : "Media Added");
        fetchMedia();

        setNewMedia({ link: "", content: "", image: images[0]?.url || "" });
        setIsEditing(false);
        setEditIndex(null);
      } catch (error) {
        // console.error("Error updating Media: ", error);
      }
    }
  };

  return (
    <div className="AddMarketingItems-Column">
      <form className="marketing-add-form" onSubmit={handleSubmit}>
        <div className="fp-form-container">
          <h3 className="FP_Content_SemiBold">Add Media</h3>
          <NewTextArea
            id="media-content"
            label="Content"
            placeholder="Content"
            required
            error={errors.content}
            value={newMedia.content}
            onChange={(event) =>
              setNewMedia((previous) => ({
                ...previous,
                content: event.target.value,
              }))
            }
            maxLength={10000}
          />
          <NewInputField
            id="media-link"
            label="Link"
            placeholder="Link"
            required
            error={errors.link}
            value={newMedia.link}
            onChange={(event) =>
              setNewMedia((previous) => ({
                ...previous,
                link: event.target.value,
              }))
            }
          />

          <div className="fp-form-column">
            <CustomSelect
              label="Select an Image"
              required
              options={images.map((image) => ({
                id: image.url,
                name: image.name,
              }))}
              value={newMedia.image}
              onChange={(event) =>
                setNewMedia((previous) => ({
                  ...previous,
                  image: event.target.value,
                }))
              }
              placeholder="Select an image"
              error={!!errors.image}
              clearable={false}
            />
            {errors.image && (
              <div className="fp-form-error FP_Help_Text">{errors.image}</div>
            )}
          </div>

          <div className="fp-form-actions">
            <PrimaryButton label="Post" />
          </div>
        </div>
      </form>
      <div className="table-scroll-container">
        <table className="marketing-content-table">
          <thead>
            <tr>
              <th>
                <div className="FP_Content"></div>
              </th>

              {/* <th>
              <div className="FP_Content">Title</div>
            </th> */}
              <th>
                <div className="FP_Content">Content</div>
              </th>
              <th>
                <div className="FP_Content">Image</div>
              </th>
              <th>
                <div className="FP_Content">Link</div>
              </th>

              {userPermissions.includes("Administrator") && (
                <>
                  <th>
                    <div className="FP_Content">Posted on</div>
                  </th>
                  <th>
                    <div className="FP_Content">Posted By</div>
                  </th>
                </>
              )}

              <th className="table-action-column">
                <div className="FP_Content">Edit</div>
              </th>
            </tr>
          </thead>

          <tbody>
            {media?.map((media, index) => (
              <tr key={index}>
                <td>
                  <div className="FP_Content">{index + 1}.</div>
                </td>
                {/* <td>{item.title}</td> */}
                <td className="item-content">
                  <div className="FP_Content">{media.content}</div>
                </td>
                <td>
                  {media.image ? (
                    <a
                      className="table-url-link"
                      href={media.image}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div className="FP_Content text-primary-1  no-text-wrap">
                        View Image
                      </div>
                    </a>
                  ) : (
                    "No Image"
                  )}
                </td>
                <td>
                  <a
                    className="table-url-link"
                    href={media.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="FP_Content text-primary-1">View</div>
                  </a>
                </td>
                {userPermissions.includes("Administrator") && (
                  <>
                    <td>
                      <div className="FP_Content">
                        {new Date(
                          media.postedOn.seconds * 1000,
                        ).toLocaleDateString()}
                      </div>
                    </td>
                    <td>
                      <div className="FP_Content  no-text-wrap">
                        {media.postedBy}
                      </div>
                    </td>
                  </>
                )}
                <td className="table-action-column">
                  <button
                    type="button"
                    className="table-row-action"
                    aria-label={`Edit media ${index + 1}`}
                    onClick={() => {
                      setNewMedia(media);
                      setEditIndex(index);
                      setIsEditing(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {isEditing && (
        <div
          className="marketing-modal-overlay"
          onClick={() => {
            setIsEditing(false);
            setNewMedia({ link: "", content: "", image: images[0]?.url || "" });
          }}
        >
          <div
            className="marketing-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <CloseIcon
              className="marketing-modal-close"
              onClick={() => {
                setIsEditing(false);
                setNewMedia({
                  link: "",
                  content: "",
                  image: images[0]?.url || "",
                });
              }}
            />
            <div className="AddMarketingItemsContainer">
              <form className="marketing-add-form" onSubmit={handleSubmit}>
                <div className="fp-form-container">
                  <h3 className="FP_H3">Edit Media</h3>
                  <NewTextArea
                    id="edit-media-content"
                    label="Content"
                    placeholder="Content"
                    required
                    error={errors.content}
                    value={newMedia.content}
                    onChange={(event) =>
                      setNewMedia((previous) => ({
                        ...previous,
                        content: event.target.value,
                      }))
                    }
                    maxLength={10000}
                  />
                  <NewInputField
                    id="edit-media-link"
                    label="Link"
                    placeholder="Link"
                    required
                    error={errors.link}
                    value={newMedia.link}
                    onChange={(event) =>
                      setNewMedia((previous) => ({
                        ...previous,
                        link: event.target.value,
                      }))
                    }
                  />

                  <div className="fp-form-column">
                    <CustomSelect
                      label="Select an Image"
                      required
                      options={images.map((image) => ({
                        id: image.url,
                        name: image.name,
                      }))}
                      value={newMedia.image}
                      onChange={(event) =>
                        setNewMedia((previous) => ({
                          ...previous,
                          image: event.target.value,
                        }))
                      }
                      placeholder="Select an image"
                      error={!!errors.image}
                      clearable={false}
                    />
                    {errors.image && (
                      <div className="fp-form-error FP_Help_Text">
                        {errors.image}
                      </div>
                    )}
                  </div>

                  <div className="fp-form-actions">
                    <PrimaryButton label="Update" />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddMedia;
